import * as React from 'react';

import Button, { IButtonProps } from '../Button';

import styled from 'styled-components';

export interface ICallToActionBannerProps {
  primaryMessage: string;
  secondaryMessage: string;
  buttonText: string;
  buttonProps: IButtonProps;
}

const CallToActionContainer = styled.div`
  border: 1px solid ${p => p.theme.color.lightGrey};
  border-radius: ${p => p.theme.borderRadius.default};
  display: flex;
  justify-content: space-between;
  padding: 1.25em;
`;

const PrimaryMessage = styled.div`
  color: ${p => p.theme.color.black2};
  font-weight: ${p => p.theme.font.weight.medium};
  margin-bottom: 0.25em;
`;

const SecondaryMessage = styled.div`
  color: ${p => p.theme.color.gray};
`;

const ActionContainer = styled.div`
  padding-left: 2em;
  white-space: nowrap;
`;

const CallToActionBanner = (props: ICallToActionBannerProps) => {
  return (
    <CallToActionContainer>
      <div>
        <PrimaryMessage>{props.primaryMessage}</PrimaryMessage>
        <SecondaryMessage>{props.secondaryMessage}</SecondaryMessage>
      </div>
      <ActionContainer>
        <Button {...props.buttonProps}>{props.buttonText}</Button>
      </ActionContainer>
    </CallToActionContainer>
  );
};

export default React.memo(CallToActionBanner);



// WEBPACK FOOTER //
// ./src/components/CallToActionBanner/index.tsx